import { ToastContainer } from 'react-toastify'
import { ChakraProvider } from '@chakra-ui/react'
import { Web3ReactProvider } from '@web3-react/core'
import connectors from 'connectors'
import { PlatformProvider } from 'contexts/PlatformContext'
import { TransactionProvider } from 'contexts/TransactionContext'
import Web3Manager from 'modules/web3/components/Web3Manager'
import type { AppProps } from 'next/app'
import { Session } from 'next-auth'
import { SessionProvider } from 'next-auth/react'
import NextNProgress from 'nextjs-progressbar'
import { chakraTheme } from 'theme/index'

import SEO from 'components/SEO/SEO'

import '@fontsource/ibm-plex-mono'

import 'styles/globals.css'
import 'react-toastify/dist/ReactToastify.css'

function MyApp({
  Component,
  pageProps: { session, ...pageProps },
}: AppProps<{ session: Session }>): JSX.Element {
  return (
    <ChakraProvider theme={chakraTheme}>
      <SEO />
      <NextNProgress
        color="#467EE5"
        stopDelayMs={200}
        options={{ showSpinner: false }}
      />
      <SessionProvider session={session}>
        <Web3ReactProvider connectors={connectors}>
          <Web3Manager />
          <PlatformProvider>
            <TransactionProvider>
              <Component {...pageProps} />
              <ToastContainer
                theme="dark"
                style={{
                  top: 85,
                }}
                autoClose={15000}
              />
            </TransactionProvider>
          </PlatformProvider>
        </Web3ReactProvider>
      </SessionProvider>
    </ChakraProvider>
  )
}

export default MyApp
